import { ChangeDetectionStrategy, Component, HostBinding, Input, OnInit, inject } from '@angular/core';

import { SuspensionState } from '@cds/betting-offer/domain-specific/bet-builder';
import { EventModel, EventOptionGroup } from '@frontend/sports/betting-offer/feature/model';
import { EpcotConfig } from '@frontend/sports/common/client-config-data-access';
import { FontResizerComponent } from '@frontend/sports/common/core/feature/font-resizer';
import { NativePriceFormatterPipe } from '@frontend/sports/odds/feature/native-price';
import { SourceOfPick } from '@frontend/sports/option/pick/feature/tracking';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

import { BetbuilderEditPrecreatedGroupButtonComponent } from '../bet-builder-core/components/button/bet-builder-edit-precreated-group-button.component';
import { BetBuilderGroupPickComponent } from '../option-pick/betbuilder-group-pick.component';
import { BetBuilderOptionGroup } from './precreated-bet-builder.model';
import { isOptionVisible } from './precreated-group-option-utils';

@Component({
    selector: 'ms-precreated-group-option',
    templateUrl: '././precreated-group-option.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        BetBuilderGroupPickComponent,
        FontResizerComponent,
        IconCustomComponent,
        NativePriceFormatterPipe,
        BetbuilderEditPrecreatedGroupButtonComponent,
    ],
})
export class PrecreatedGroupOptionComponent implements OnInit {
    private epcotConfig = inject(EpcotConfig);

    @Input() optionGroup: BetBuilderOptionGroup;
    @Input() eventOptionGroups: EventOptionGroup[];
    @Input() event: EventModel;
    @Input() showSGPButtonsInPrebuiltSGP: boolean;
    @Input() sourceOfPick: SourceOfPick;

    @HostBinding('class') className = 'betbuilder-market-card';
    optionGroupLegs: string[];
    isEpcotEnabled = false;
    pickTrackingSource = 'eventdetails/build a bet option group pod/betbuilder/';

    get isSuspended(): boolean {
        const suspendedOptions = this.eventOptionGroups?.flatMap((og) => og.options?.filter((o) => isOptionVisible(o) && !o.online));
        const isSuspendedOffer = this.optionGroup.externalGroupInfo.options?.some((o) => suspendedOptions?.some((vo) => vo.id === o.id));

        const isSuspendedPricing = this.optionGroup.externalGroupInfo.builderOptionPricing.suspensionState === SuspensionState.MarketSuspended;

        return isSuspendedPricing || isSuspendedOffer;
    }

    constructor() {
        this.isEpcotEnabled = this.epcotConfig.isEnabled;
    }

    ngOnInit(): void {
        this.optionGroupLegs = this.optionGroup.options.flatMap((option) => option.marketName + ' - ' + option.name);
    }
}
